import { createAsyncThunk } from '@reduxjs/toolkit';

import { BasicInfoHttpGetService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

export const getAllNesbatHa = createAsyncThunk('Nesbat/getAllNesbatHa', async () => {
  return await BasicInfoHttpGetService({
    url: `${_apiPathManagerConfig?.BasicInfo.Nesbat.GetAllNesbatHa}`,
  });
});
